import { get } from 'svelte/store';
import { push } from 'svelte-spa-router';
import { format } from 'svelte-i18n';
import { setUpI18n } from './i18n';

import qs from 'qs';

import sha256 from 'crypto-js/sha256';

import {
	real_id,
	is_gen_2,
	get_ip,
	get_ssid,
	isBluRC,
	isBluRotaryKnob,
	isRgbwwPm,
} from '../helpers/interface_helpers';
import {
	_deepClone,
	checkIfColorIsAvatarVariant,
	convert_array_to_object,
	convertLegacyAvatarColors,
	decimal_to_hex,
} from '../helpers/utilities';

import { authenticateDevice } from 'src/helpers/requests/authenticate';

import { FW_FOR_UPDATE } from '../constants';

import { user_data, user_settings, home_data, profile_data } from 'src/stores/account/user';
import { device_auths, auth_locked_devices } from 'src/stores/device-runtime/local-auth';
import { firmwares, firmwares_gen_2, firmwares_gen_gble } from 'src/stores/device-runtime/process';
import { devices_status, devices_settings } from 'src/stores/device-runtime/status';
import { active_integrations } from 'src/stores/integrations/alexa';
import { devices } from 'src/stores/lists/devices';
import { groups } from 'src/stores/lists/groups';
import { rooms } from 'src/stores/lists/rooms';
import { app, os, network } from 'src/stores/session/native-bridge';
import { initializing_language } from 'src/stores/session/preferences';
import { rating_prompt_status, paypal_info } from 'src/stores/ui/promotions';

import { getWeatherStationData } from '../helpers/geolocalion_helper';

import { ongoingDiscovery } from 'src/stores/features/discovered';

import { scenes } from 'src/stores/lists/scenes';
import { loadingData } from 'src/stores/ui/loading-data';

import { authLockedDeviceModal, unauthorisedRequests } from 'src/stores/device-runtime/firmware-ui';
import { dashboards } from 'src/stores/features/dashboards';

import {
	credentials_put_ios,
	init_discover_devices_ios,
	is_alexa_app_installed_ios,
	login_mobile_ios,
} from '../services/native_container_requests_ios';

import {
	init_discover_devices_android,
	is_alexa_app_installed_android,
	login_mobile_android,
} from '../services/native_container_requests_android';

import {
	set_devices_data_ios,
	set_scenes_data_ios,
	set_alarms_data_ios,
} from '../services/lists_update_ios';
import { set_scenes_data_android, set_alarms_data_android } from '../services/lists_update_android';

import type { Device } from '../types/Device';
import type { Request } from '../types/requests/request';
import type { CloudApiResponse } from 'src/types/responses/CloudApiResponse';
import type { UserPinRequest } from '../types/requests/services/user_pin';
import type { ChangePasswordRequest } from '../types/requests/services/change_password';
import type { AllListsRequest } from '../types/requests/services/all_lists';
import type { SceneListsRequest } from '../types/requests/services/scene_lists';
import type { UserSettingsRequest } from '../types/requests/services/user_settings';
import type { UserHomeDataRequest } from '../types/requests/services/user_home_data';
import type { UserProfileDataRequest } from '../types/requests/services/user_profile_data';
import type { GetFwVersionsRequest } from '../types/requests/services/get_fw_version';
import type { GetActiveIntegrationsRequest } from '../types/requests/services/get_active_integrations';

import { applicationHostUrl } from '../helpers/account_helpers';
import { adaptingPowerPricesByTimeZoneIfOutdated } from '../helpers/power_prices_helpers';
import { getLegacyNewsletterPreference, normalizeProfileData } from '../helpers/profile_data_helpers';

//Design system components
import { toast } from '@Shelly/shelly-design-system';
import { castUsageStringToRelayUsageParam, getApplianceType } from 'src/helpers/device_settings_helpers';
import { devices_config_wave } from 'src/devices_config_wave';
import { socket_connect } from './socket';
import { getDevicesCache, getDevicesState, backfillCloudRelayLists } from './iotu/v2_device_state';
import { getThermostatsStatus } from './iotu/v2_virtual_thermostats_status';
import { getBLUDeviceMode } from 'src/helpers/web_bluetooth/web_bluetooth_inclusion_helpers';
import { expireTime, startWatchExpire } from './auth_token';
import { DEV_SERVER_TAGS, isDevServerUser, isT1User } from 'src/helpers/user_server_conditions';
import { HttpClient } from './utils/http-client';
import { startNotificationsProcessing } from 'src/helpers/notifications/device_notifications_helper';
import { getProfileAvatarText, profiles } from 'src/stores/features/profiles';
import { authLogin, authRefreshToken, nativeLogin } from './auth_v2';
import { isReadyToInitializeModalsStore, modalStore } from 'src/stores/ui/modal_states';
import { ValidateEmailPromptModalConfig } from 'src/configs/modals/ValidateEmailPromptModalConfig';
import { device_ui } from 'src/stores/features/device-ui';
import { NativeOperationSystem } from './init/types/init-type';
import { ratingPromptHelper } from 'src/helpers/rating_propmpt_helpers';
import { getCurrentUnitPremiumInfo } from 'src/helpers/paypal_info_helpers';
import type { ISceneObj } from 'src/types/SceneType';
import { validate_scene } from 'src/components/Scenes/helpers/validators';
import { setSentryRelatedData } from './sentry';
import { refreshHomes } from 'src/stores/account/home';
import { cameraServicesInitialLoad } from '../components/Camera/helpers/camera-cloud';

let _format = get(format);

// Replace once we are to begin axiox removal
export const local = new HttpClient('http://');
export const api = new HttpClient(import.meta.env.VITE_API_URL);
export const repo = new HttpClient(import.meta.env.VITE_REPO_URL);
export const cloud = new HttpClient(import.meta.env.VITE_CLOUD_URL, 6000);
export const cameraCloudApi = new HttpClient(import.meta.env.VITE_CAMERA_CLOUD_API, 10000);

export const cloud_upload = new HttpClient(import.meta.env.VITE_CLOUD_URL, 6000);
export const shendure = new HttpClient(import.meta.env.VITE_API_SHENDURE, 10000);
export const loqedApi = new HttpClient(import.meta.env.VITE_API_LOQED, 6000);
export const paypal = new HttpClient(import.meta.env.VITE_API_PAYPAL, 6000);
export const rateService = new HttpClient('https://app-ratings.shelly.cloud/', 6000);
export const paypalTest = new HttpClient(import.meta.env.VITE_API_PAYPAL_TEST, 6000);
export const changelogApi = new HttpClient(import.meta.env.VITE_CHANGELOG_API_URL, 10000);

/**
 * Connects to the Cloud API by handling user authentication and data retrieval.
 * Native login is performed followed by token handling and data pulling.
 * Prevoiously named `http()`
 *
 * @returns Promise<bolean | any>
 */
export const connectToCloudApi = async () => {
	const stored_user = get(user_data);
	const stored_token = user_data.getToken();
	const stored_user_settings = get(user_settings);

	if (Object.keys(stored_user).length === 0) {
		handle_base_url('API_URL');
		return false;
	}

	handle_base_url(stored_user.user_api_url);
	nativeLogin(
		stored_user.email,
		stored_user.password,
		stored_user.user_api_url,
		stored_user.token,
		stored_user_settings.lang,
	);

	if (expireTime(stored_token) > 0) {
		handleToken(stored_token);
		await pullDataWithLoading();
	} else {
		await authRefreshToken();
		pullDataWithLoading();
	}

	get_user_pin();
};

// TODO: refactor as part of #2986
// This will be a challengee as this function is the main communicator with the cloud api
export const postReq: (
	url: string,
	data: any,
	timeout?: number,
	instance?: string,
	handle_error?: boolean,
	json?: boolean,
	headers?: Record<string, string | object>,
) => Promise<CloudApiResponse> = async (
	url,
	data,
	timeout = 6000,
	instance,
	handle_error = true,
	json = false,
	headers?: Record<string, string | object>,
) => {
	data = json ? JSON.stringify(data) : qs.stringify(data);

	let config = {
		timeout,
		headers: {
			...headers,
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	};

	if (json) {
		config = {
			...config,
			data: null,
			headers: {
				...headers,
				'Content-Type': 'application/json',
			},
		};
	}
	try {
		if (instance) {
			url = `https://${instance}/${url}`;
		}
		const res = await cloud.post(url, data, config);
		return res.data;
	} catch (error) {
		console.error(`postReq call error to ${url}`, error?.code);
		console.error('postReq call error', error?.response);
		const data = error?.response?.data;
		if (handle_error && typeof data?.errors?.code !== 'undefined') {
			toast.open({
				type: 'danger',
				title: _format(`error_${data.errors.code}`),
			});
		}
		return { ...data, isok: false };
	}
};

export const getReq: (
	url: string,
	data: any,
	timeout?: number,
	instance?: string,
	handle_error?: boolean,
	json?: boolean,
) => Promise<Request> = async (url, data, timeout = 6000, instance, handle_error = true) => {
	data = qs.stringify(data);
	let config = {
		timeout,
		headers: {
			'Content-Type': 'application/json',
		},
	};
	try {
		if (instance) {
			url = `https://${instance}/${url}`;
		}
		const res = await cloud.get(`${url}?${data}`, config);
		return res;
	} catch (error) {
		console.error('getReq call error', error?.response);
		const data = error?.response?.data;
		if (handle_error && typeof data?.errors?.code !== 'undefined') {
			toast.open({
				type: 'danger',
				title: _format(`error_${data.errors.code}`),
			});
		}
		return { ...data, isok: false };
	}
};

/**
 * Generates authentication parameters for HTTP requests.
 * Matches gen2-embedded-web: auth sent per request; nc incremented when reusing same nonce.
 *
 * Credentials are hardened (FE-1998): a precomputed `ha1` is preferred and the plaintext
 * `pass` is only used as a legacy fallback for not-yet-migrated entries.
 *
 * @param auth_data - The authentication data string (www-authenticate).
 * @param pass - The plaintext password (legacy fallback only).
 * @param fwVersion - The firmware version (kept for signature compatibility; unused).
 * @param nc - Nonce count; use 1 for first use of a nonce, then increment per request.
 * @param ha1 - Precomputed `SHA256("admin:" + realm + ":" + password)`; used when present.
 * @returns An object containing the authentication parameters.
 */
export function generateAuthParams(auth_data, pass, fwVersion, nc = 1, ha1?: string) {
	if (!auth_data) return;
	const auth_details = Object.fromEntries(
		auth_data.split(', ').map((v) => v.replace('Digest ', '').split('=')),
	);

	const user = 'admin';
	const cnonce = Date.now();
	const digest_uri = { method: 'dummy_method', path: 'dummy_uri' };

	const ncVal = typeof nc === 'number' ? nc : 1;
	const ncHex = ncVal.toString(16).padStart(8, '0');
	const realm = auth_details?.realm?.replace(/"/g, '') ?? '';
	const rawNonce = auth_details?.nonce?.replace(/"/g, '') ?? '';
	const nonceForHash = rawNonce;
	const nonceOut = /^\d+$/.test(rawNonce) ? parseInt(rawNonce, 10) : rawNonce;

	const HA1 = ha1 ? ha1 : sha256(user + ':' + realm + ':' + pass).toString();
	const HA2 = sha256(digest_uri.method + ':' + digest_uri.path).toString();
	const combined =
		HA1 + ':' + nonceForHash + ':' + ncHex + ':' + String(cnonce) + ':' + 'auth' + ':' + HA2;
	const shaResponse = sha256(combined).toString();

	return {
		realm,
		username: user,
		nonce: nonceOut,
		cnonce,
		nc: ncHex,
		response: shaResponse,
		algorithm: 'SHA-256',
	};
}

/**
 * Makes a local HTTP request.
 *
 * @param {any} device - The device object.
 * @param {any} url - The URL to make the request to.
 * @param {any} method - The HTTP method to use for the request.
 * @param {any} data - The data to send with the request.
 * @param {number} [timeout=10000] - The timeout for the request in milliseconds.
 * @param {boolean} [qs_ify=false] - Whether to convert the data to query string format.
 * @param {boolean} [showAuthUnlockModal=true] - Whether to show the authentication unlock modal.
 * @param {boolean} [skip_check=false] - Whether to skip the check for the device inclusion process.
 * @returns {Promise<Request>} - A promise that resolves to the request result.
 */
export const localReq: (
	device: any,
	url: any,
	method: any,
	data: any,
	timeout?: number,
	qs_ify?: boolean,
	showAuthUnlockModal?: boolean,
	skip_check?: boolean,
) => Promise<Request> = async (
	device,
	url,
	method,
	data,
	timeout = 10000,
	qs_ify = false,
	showAuthUnlockModal = true,
	skip_check = false,
) => {
	if (!skip_check && !device?.id) {
		return { isok: false, status: 400 };
	}
	const isGen2 = is_gen_2(device);
	const id = real_id(device.id);
	const auth = get(device_auths)[id];
	const options = {
		timeout: timeout,
		headers: {},
	};

	if (auth) {
		if (isGen2) {
			if (typeof device !== 'undefined' && typeof auth.auth_data !== 'undefined') {
				const nc = typeof auth.nc === 'number' ? auth.nc : 1;
				let fwVersion;
				try {
					fwVersion = await getFwVersion(device);
				} catch {
					fwVersion = undefined;
				}
				data.auth = generateAuthParams(auth.auth_data, auth.pass, fwVersion, nc, auth.ha1);
				device_auths.update(id, { ...auth, nc: nc + 1 });
			} else if (!auth.ha1) {
				// No usable credential (no challenge cached and no ha1) — drop it.
				device_auths.remove(id);
			}
			// When only `ha1` is cached (e.g. right after enabling protection via Shelly.SetAuth)
			// we keep the entry and let the request proceed unauthenticated; the resulting 401 is
			// handled by handleUnauthorizedRequest, which signs the retry with the cached ha1.
		} else {
			options.headers = {
				Authorization: `Basic ${btoa(auth.user + ':' + auth.pass)}`,
			};
		}
	}

	const _data = prepareData(qs_ify, isGen2, data);

	try {
		const res = await makeRequest(url, method, _data, options);
		// auth_locked_devices.remove(device.id);
		if (is_gen_2(device)) {
			return { ...res?.data?.result, isok: true };
		} else {
			return { ...res?.data, isok: true };
		}
	} catch (error) {
		console.error('error', error);

		// if (import.meta.env.DEV && onlyLocalRequests) {
		// 	toast.open({ type: 'danger', title: `Your request to ${url} has been blocked CORS while trying to test ONLY local requests. Check if you are on the same wi-fi network as the device. Also for this dev option to work please open a non-CORS protected chrome version: https://alfilatov.com/posts/run-chrome-without-cors/` });
		// 	return { isok: false };
		// }

		const isUnauthorized = error?.response?.status === 401 || error?.status === 401;
		const isDeviceOnline =
			skip_check ||
			get(devices_status)[id]?.online === true ||
			get(devices_status)[id]?.online == 1;

		const applyLockAndModal = () => {
			const unauthorisedResponse = getWwwAuthenticateFromError(error);
			device_auths.remove(id);
			auth_locked_devices.add(id);
			if (showAuthUnlockModal) {
				authLockedDeviceModal.set(device.id);
			}
			unauthorisedRequests.update((d) => {
				return {
					...d,
					[id]: { responseHeaders: unauthorisedResponse, payload: data, url },
				};
			});
		};

		const storedAuth = auth ?? get(device_auths)[id];
		if (isUnauthorized && storedAuth) {
			const res = await handleUnauthorizedRequest(
				device,
				storedAuth,
				url,
				method,
				data,
				options,
				error,
			);
			if (res.isok) {
				return res;
			}
			if (isDeviceOnline) {
				applyLockAndModal();
			}
			return { ...error?.response?.status, ...error.response, isok: false };
		}

		if (isUnauthorized && isDeviceOnline) {
			applyLockAndModal();
			return { ...error?.response?.status, ...error.response, isok: false };
		}

		return { ...error?.response?.status, ...error.response, isok: false };
	}
};

/**
 * Handles unauthorized requests by updating the unauthorisedRequests state, authenticating the device, and making a request with updated authentication parameters.
 *
 * @param device - The device object.
 * @param auth - The authentication object.
 * @param url - The URL of the request.
 * @param method - The HTTP method of the request.
 * @param data - The data payload of the request.
 * @param options - Additional options for the request.
 * @param error - The error object, if any.
 * @returns The response from the request or an error object.
 */
const getWwwAuthenticateFromError = (err: any) => {
	const h = err?.response?.headers;
	if (!h) return undefined;
	return (
		h['www-authenticate'] ??
		h['WWW-Authenticate'] ??
		(typeof h.get === 'function'
			? (h.get('www-authenticate') ?? h.get('WWW-Authenticate'))
			: undefined)
	);
};

const handleUnauthorizedRequest = async (
	device: Device,
	auth: any,
	url: any,
	method: any,
	data: any,
	options: any,
	error?: any,
) => {
	const unauthorisedResponse = getWwwAuthenticateFromError(error);
	const id = real_id(device.id);
	unauthorisedRequests.update((d) => {
		return {
			...d,
			[id]: { responseHeaders: unauthorisedResponse, payload: data, url },
		};
	});
	if (!unauthorisedResponse) {
		return { isok: false };
	}
	let [_, _url, _method, _data, _timeout, _qs_ify, _showAuthUnlockModal] = authenticateDevice(device);
	if (is_gen_2(device)) {
		try {
			_url = new URL(_url).origin + '/rpc/';
			_data = { id: Date.now(), method: 'Shelly.GetStatus', src: 'ShellyApp' };
		} catch {
			/* keep stored url/payload */
		}
	}
	const fwVersion = await getFwVersion(device);
	_data.auth = generateAuthParams(unauthorisedResponse, auth.pass, fwVersion, 1, auth.ha1);
	const _preparedData = prepareData(_qs_ify, is_gen_2(device), _data);
	try {
		const res = await makeRequest(_url, _method, _preparedData, options);
		if (is_gen_2(device)) {
			// Persist the fresh challenge so subsequent requests use the fast (pre-signed) path
			// instead of repeating the 401 round-trip. Important when only `ha1` was cached
			// (e.g. right after enabling protection via Shelly.SetAuth).
			device_auths.update(id, { ...auth, auth_data: unauthorisedResponse, nc: 2 });
			return { ...res?.data?.result, isok: true };
		}
		return { ...res?.data, isok: true };
	} catch (err) {
		device_auths.remove(id);
		console.log('error', err);
		return { ...err?.response, isok: false };
	}
};
/**
 * Makes an HTTP request.
 *
 * @param {string} url - The URL to make the request to.
 * @param {string} method - The HTTP method to use for the request.
 * @param {any} data - The data to send with the request.
 * @param {any} options - Additional options for the request.
 * @returns {Promise<any>} - A promise that resolves to the response from the server.
 */
const makeRequest = async (url: any, method: any, data: any, options: any) => {
	let res;
	if (method == 'post') {
		res = await local.post(url, data, options);
	} else {
		res = await local.get(url, options);
	}
	return res;
};
/**
 * Prepares the data for HTTP requests.
 *
 * @param {boolean} qs_ify - Indicates whether to use query string format for the data.
 * @param {boolean} isGen2 - Indicates whether the data is for Gen2.
 * @param {any} data - The data to be prepared.
 * @returns {string} - The prepared data.
 */
const prepareData = (qs_ify: boolean, isGen2: boolean, data: any) => {
	if (qs_ify) {
		return qs.stringify(data);
	} else {
		return isGen2 ? JSON.stringify(data) : qs.stringify(data);
	}
};
const getFwVersion = async (device: any) => {
	if (!device?.fw || !device?.fw?.match(/(\d{1,}\.){1,}\d{1,}/)?.[0]) {
		const getInfo = await local.get(`${device.ip}/shelly`);

		device.fw = getInfo?.data?.ver;
		// devices.update(device);
	}
	return device?.fw?.match(/(\d{1,}\.){1,}\d{1,}/)?.[0];
};

export const handle_base_url = (url) => {
	cloud.setUrl(url);
	cloud_upload.setUrl(url);
	// Keep the camera cloud API in sync with the user's server: dev-server users
	// (repo/t1/nb) must hit the camera test cloud, everyone else the production one.
	if (isDevServerUser(DEV_SERVER_TAGS)) {
		handle_camera_base_url(import.meta.env.VITE_CAMERA_TEST_CLOUD_API);
	} else {
		handle_camera_base_url(import.meta.env.VITE_CAMERA_CLOUD_API);
	}
};

export const handle_camera_base_url = (url) => {
	cameraCloudApi.setUrl(url);
};

// TODO(aav): refactor for all services
// TOKEN ----------------------------------------------------------------------------------
export const clearToken = () => {
	cloud.clearAuthToken();
	repo.clearAuthToken();
	shendure.clearAuthToken();
	loqedApi.clearAuthToken();
	paypal.clearAuthToken();
	paypalTest.clearAuthToken();
	rateService.clearAuthToken();
	cameraCloudApi.clearAuthToken();
};

export const handleToken = (jwt) => {
	cloud.setAuthToken(jwt);
	repo.setAuthToken(jwt);
	shendure.setAuthToken(jwt);
	loqedApi.setAuthToken(jwt);
	paypal.setAuthToken(jwt);
	paypalTest.setAuthToken(jwt);
	rateService.setAuthToken(jwt);
	cameraCloudApi.setAuthToken(jwt);
	startWatchExpire(jwt);
};

// @ToDo: Refactor all occurances for direct use of the new login function `services/auth`
/**
 * @deprecated
 * */
export const standardLogin = (email, pass, unitId?: string, subId?: string) => {
	/**
	 * Legacy v1 login
	 * * @deprecated
	 */
	// return v1_standardLogin(email, pass);
	/** END of Legacy v1 login */

	// iotu v2 refresh token function
	return authLogin(email, pass, unitId, subId);
};

// @ToDo: Refactor all occurances for direct use of the new refresh function `services/auth`
/**
 * @deprecated
 * */
export const crefresh_token = () => {
	/**
	 * Legacy v1 refresh token function
	 * * @deprecated
	 */
	// return v1_crefresh_token();
	/** END of Legacy v1 refresh token */

	// iotu v2 refresh token function
	return authRefreshToken();
};

export const get_user_pin = async () => {
	const res: UserPinRequest = await postReq('/user/get_user_pin', {});

	if (res?.isok) {
		user_data.set({ ...get(user_data), lock_pin: res.data.user_pin });
	}
	return res;
};

// LOGIN ---------------------------------------------------------------------------------
export const req_password = async (email) => {
	//this will set control.shelly.cloud for clients which are using app.
	const url = applicationHostUrl(
		import.meta.env.VITE_APP_BUCKET || window.location.host,
		'/#/password-reset',
	);
	try {
		let res = await cloud.post(
			'/auth/reset_password',
			qs.stringify({
				email: email,
				url,
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);
		toast.open({
			type: 'info',
			title:
				_format('pass_req_sent', { values: { value: email } }) || 'New password was requested.',
		});
		return { isok: res };
	} catch (error) {
		const errorMessageKey = Object.keys(error.response.data.errors)[0];
		return { error: errorMessageKey };
	}
};

// REGISTER --------------------------------------------------------------------------------
export const handleRegister = async (email, pass, timezone) => {
	// const hashPass = sha1(pass).toString();
	try {
		const res = await api.post(
			'/auth/register',
			qs.stringify({
				email: email,
				password: window.btoa(pass).toString(),
				timezone: timezone,
				lang: get(initializing_language) || 'en',
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);

		return res.data;
	} catch (error) {
		const errorMessageKey = Object.keys(error.response.data.errors)[0];
		return { isok: false, errors: error.response.data.errors };
	}
};

// RESET PASSWORD --------------------------------------------------------------------------------
export const confirmPasswordReset = async (token, pass) => {
	try {
		await api.post(
			'/auth/confirm_reset_password',
			qs.stringify({
				token,
				new_password: window.btoa(pass).toString(),
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);
		toast.open({
			type: 'success',
			title: _format('password_reset_success'),
			duration: 5000,
		});

		push('/login');
	} catch (error) {
		return { isok: false, error };
	}
};

// CHANGE TIMEZONE --------------------------------------------------------------------------
export const handleChangeTimeZone = async (timezone) => {
	try {
		const res = await postReq('/user/set_timezone', {
			timezone,
		});

		if (res.isok) {
			user_data.set({ ...get(user_data), timezone });
		}
	} catch (error) {
		console.log('error on change timezone ', error);
	}
};

export const handleUserProfileName = async (name): Promise<boolean> => {
	try {
		const res = await postReq('/user/set_screen_name', {
			name,
		});
		if (res.isok) {
			user_settings.set({ ...get(user_settings), name });
			return true;
		}
		return false;
	} catch (error) {
		console.log('error on name change ', error);
		return false;
	}
};

export const handleUserProfileAvatar = async (acc_avatar): Promise<boolean> => {
	try {
		const res = await postReq('/user/set_acc_avatar', {
			acc_avatar: JSON.stringify(acc_avatar),
		});
		if (res.isok) {
			user_settings.set({ ...get(user_settings), acc_avatar });
			return true;
		}
		return false;
	} catch (error) {
		console.log('error on avatar change', error);
		return false;
	}
};

export const handleUserGivenRating = async (rating) => {
	console.log('test rating', rating);
	try {
		const res = await rateService.post('', JSON.stringify(rating));
		return res;
	} catch (error) {
		console.log('error on rating change ', error);
	}
};

//CHANGE PASSWORD --------------------------------------------------------------------------
export const handleChangePassword = async (oldPass, newPass, repeatPass) => {
	console.log(oldPass, newPass, repeatPass, 'CHANGE PASSWORD');
	if (newPass !== repeatPass) {
		alert('the new password dont match');
	} else {
		try {
			const b64pass = window.btoa(newPass).toString();
			let data: ChangePasswordRequest = await postReq('/user/change_password', {
				old_password: window.btoa(oldPass),
				new_password: window.btoa(newPass),
			});

			await user_data.set({
				lock_pin: data.pin,
				email: data.email,
				password: b64pass,
				timezone: data.timezone,
				lang: data.lang,
				user_api_url: data.user_api_url,
				token: data.token,
			});
			await push('/login');
		} catch (error) {
			console.log('error on change password', error);
		}
	}
};

//SET PIN ----------------------------------------------------------------------------------
export const handleUserPin = async (pin) => {
	if (pin.length < 4) {
		alert('The pin must be 4 digits.');
		return;
	} else {
		try {
			const res = await postReq('/user/set_user_pin', {
				pin,
			});

			if (res.isok) {
				user_settings.set({ ...get(user_settings), pin });
			}

			// await user_data.set({ lock_pin: pin, email: data.email, password: password, timezone: data.timezone, lang: data.lang, user_api_url: data.user_api_url, token: data.token });
			console.log(res, 'DATA PIN');
		} catch (error) {
			console.log('error on set pin', error);
		}
	}
};

export const update_files_mobile = async (ip) => {
	const req = new XMLHttpRequest();
	req.open('GET', 'shelly://download_new_files/?url=' + ip);
	req.send();
};

export const read_qr_code = async () => {
	const res = await postReq('shelly://scan_qr_code/', {});
};

const setOtherData = (ratingPromptState, paypalInfo) => {
	const isApp = get(app);
	const platform = get(os);

	// Set rating prompt and paypal info and init modals and notificaitons
	rating_prompt_status.set(ratingPromptState);
	paypal_info.set(paypalInfo);
	startNotificationsProcessing();
	modalStore.addModal(ValidateEmailPromptModalConfig);
	isReadyToInitializeModalsStore.set(true);

	if (!isApp) {
		return;
	}

	if (platform === NativeOperationSystem.IOS) {
		is_alexa_app_installed_ios();
		return;
	}

	is_alexa_app_installed_android();
};

const setHomeRelatedData = async () => {
	const _user_data = get(user_data);
	const _user_settings = get(user_settings);
	const homeData = get(home_data);

	await setUpI18n(_user_settings.lang);
	if (get(app) && get(os) === NativeOperationSystem.IOS) {
		const userData = {
			password: _user_data.password,
			username: _user_data.email,
			user_url: _user_data.user_api_url,
		};

		set_devices_data_ios(userData, get(devices));
	}

	if (
		get(app) &&
		get(network) === 'wifi' &&
		!get(ongoingDiscovery) &&
		homeData?.globalLocalControl?.useLocal
	) {
		// get discovered devices
		if (get(os) === 'IOS') {
			init_discover_devices_ios();
		} else {
			init_discover_devices_android();
		}
		ongoingDiscovery.set(true);
		setTimeout(() => {
			ongoingDiscovery.set(false);
		}, 20000);
	}
};
//#region Initial load
export const handleInitialLoad = async () => {
	console.info('Initial loading of account data');

	modalStore.setIsInitialized(false);
	isReadyToInitializeModalsStore.set(false);

	try {
		// Single homes refresh, early, so native containers receive the homes list
		// before devices/lists load. `get_user_settings()` / `getAllLists()` do not
		// mutate homes, so a second refresh afterwards would be a duplicate request.
		await refreshHomes();
		await get_user_settings();
		await getAllLists();
		cameraServicesInitialLoad();

		await Promise.all([getDevicesState(), getDevicesCache(), getThermostatsStatus()]);
		backfillCloudRelayLists();
		socket_connect();
		await get_active_integrations();
	} finally {
		loadingData.set(false);
	}

	cacheNetworkData();
	get_scenes();
	// Load home- and account-scoped data in parallel, but wait for both before
	// account preferences are consumed by menus and modals.
	const homeDataPromise = get_home_data()
		.then(() => {
			setHomeRelatedData();
		})
		.catch((error) => {
			console.error('Failed to load home data during initial load', error);
		});
	const profileDataPromise = get_profile_data().catch((error) => {
		profile_data.set({});
		console.error('Failed to load profile data during initial load', error);
	});

	await getLatestFirmwares();
	await Promise.all([homeDataPromise, profileDataPromise]);
	await migrateLegacyNewsletterPreference();
	await Promise.all([ratingPromptHelper(), getCurrentUnitPremiumInfo()]).then(
		([ratingPromptState, paypalInfo]) => {
			setOtherData(ratingPromptState, paypalInfo);
		},
	);

	setSentryRelatedData();
	return true;
};

export const getLatestFirmwares = async () => {
	//ToDo: check for at least one gen 1 device
	const _firmwares = get(firmwares);
	if (typeof _firmwares.ts === 'undefined' || Date.now() > _firmwares?.ts + 3600 * 1000) {
		await get_all_fw_versions();
	}
	//ToDo: check for at least one gen 2 device
	const _firmwares_gen_2 = get(firmwares_gen_2);
	if (typeof _firmwares_gen_2.ts === 'undefined' || Date.now() > _firmwares_gen_2?.ts + 3600 * 1000) {
		await get_all_fw_versions_gen_2();
	}
	//ToDo: check for at least one gen ble device
	const _firmwares_gen_gble = get(firmwares_gen_gble);
	if (
		typeof _firmwares_gen_gble.ts === 'undefined' ||
		Date.now() > _firmwares_gen_gble?.ts + 3600 * 1000
	) {
		await get_all_fw_versions_gen_gble();
	}
};

export const pullDataWithLoading = async () => {
	if (!get(loadingData)) {
		loadingData.set(true);
		await handleInitialLoad();
	}
};

const cacheNetworkData = async () => {
	const _devices = get(devices);
	const edited_devices = {};

	for (let [id, device] of Object.entries(_devices)) {
		let hasNetworkChange = false;
		const ip = get_ip(devices_status.getByRealId(id));
		const ssid = get_ssid(devices_settings.getByRealId(id), devices_status.getByRealId(id), device);
		if (typeof ip !== 'undefined' && device.ip !== ip) {
			device.ip = ip;
			hasNetworkChange = true;
		}
		if (typeof ssid !== 'undefined' && device.ssid !== ssid) {
			device.ssid = ssid;
			hasNetworkChange = true;
		}
		hasNetworkChange ? (edited_devices[id] = device) : '';
	}

	devices.massUpdate(edited_devices);

	if (Object.keys(edited_devices).length > 0) {
		const res = await postReq(`interface/device/bulk_update`, {
			devices_data: JSON.stringify(edited_devices),
		});
		if (res.isok) {
			console.log('Updated devices', res);
		}
	}
};

const fix_bad_values_devices = async (devices) => {
	const edited_devices = {};

	let fixed_devices = Object.values(devices)
		.filter((v: any) => typeof v.category !== 'undefined' && typeof v.type !== 'undefined')
		.map((v: any) => {
			try {
				if (typeof v.id === 'number') {
					v.id = v.id + '';
				}

				if (v.category === 'shendure') {
					v.category = 'pv';
					edited_devices[v.id] = v;
				}

				if (v.image && (v?.icon || v?.backgroundColor)) {
					v.image = '';
					edited_devices[v.id] = v;
				}

				// Convert legacy backgroundColor format to new AvatarColorVariant format
				if (v?.backgroundColor) {
					const convertedColor = convertLegacyAvatarColors(v.backgroundColor);
					if (convertedColor !== v.backgroundColor) {
						v.backgroundColor = convertedColor;
						edited_devices[v.id] = v;
					}
				}

				if (
					v.gen !== 'GBLE' &&
					v.gen !== 'GZ' &&
					v.gen !== 'GXP' && // Zendure
					v.gen !== 'GXL' && // Loqed
					typeof v.gen !== 'number'
				) {
					v.gen = Number(v.gen);
					edited_devices[v.id] = v;
				}

				if (v.type == 'SHIX3-1' && (v.gen == 0 || typeof v.gen !== 'number')) {
					v.gen = 1;
					edited_devices[v.id] = v;
				}

				if (v.isDndShadowItem) {
					delete v.isDndShadowItem;
					edited_devices[v.id] = v;
				}

				if (v.position === null) {
					v.position = 0;
					edited_devices[v.id] = v;
				}

				if (
					(v.type == 'SBBT-002C' ||
						v.type == 'SBBT-102C' ||
						v.type == 'SBBT-102CEU' ||
						v.type == 'SBDW-002C' ||
						v.type == 'SBDW-103C' ||
						v.type == 'SBHT-003C' ||
						v.type == 'SBHT-103C' ||
						v.type == 'SBHT-203C' ||
						v.type == 'SBMO-003Z' ||
						v.type == 'SBMO-103Z' ||
						v.type == 'SBRC-005B' ||
						v.type == 'SBRK-002C' ||
						v.type == 'SBSN-001B' ||
						v.type == 'SMSN-0031ZL') &&
					v.gen !== 'GBLE'
				) {
					v.gen = 'GBLE';
					edited_devices[v.id] = v;
				}
				if ((isBluRC(v.type) || isBluRotaryKnob(v.type)) && v.family !== 'remote_control') {
					// v.category = 'remote_control';
					// v.family = 'remote_control';
					edited_devices[v.id] = v;
				}

				if (
					v.gen === 'GBLE' &&
					(v.category === 'inputs_reader' || v.mode === 'inputs_reader') &&
					(v.type === 'SBDW-002C' ||
						v.type === 'SBDW-103C' ||
						v.type === 'SBHT-003C' ||
						v.type === 'SBHT-103C' ||
						v.type == 'SBHT-203C' ||
						v.type == 'SBMO-003Z' ||
						v.type == 'SBMO-103Z' ||
						v.type == 'SBSN-001B')
				) {
					v.mode = v.category || getBLUDeviceMode(v.type);
					edited_devices[v.id] = v;
				}

				if (typeof v?.dsk !== 'undefined' && v.type.includes('QNS') && v.gen !== 'GZ') {
					//overriding gen z because mostly they are gen 1 or gen 0
					v.category = devices_config_wave[v.type].family; //fixing category if its wrongly set
					v.gen = 'GZ';
					edited_devices[v.id] = v;
				}

				if (v.room_id == '') {
					v.room_id = -10;
					edited_devices[v.id] = v;
				}

				if (!v.name) {
					console.log('the device has no name prop', v);
					v.name = 'unnamed';
					edited_devices[v.id] = v;
				}

				// legacy! will remain here as a reminder of what NOT to do
				// if (typeof v.image !== 'undefined') {
				// 	if (v.image.includes('assets/predefined_images/device/')) {
				// 		let _image = v.image
				// 			.split(/[\\/]/)
				// 			.pop()
				// 			.replace(/\.[^/.]+$/, '');
				// 		_image = _image.includes('_') ? _image.split('_')[0] : _image;
				// 		v.image = `images/device_images/predefined_images/${_image}.png`;
				// 	}
				// }

				if (typeof v.external_sensors_names !== 'undefined') {
					if (
						typeof v.external_sensors_names['0_humidity'] === 'undefined' &&
						v.external_sensors_names[0]?.type === 'humidity'
					) {
					}
					for (let i = 0; i < 2; i++) {
						if (
							typeof v.external_sensors_names[i + '_temperature'] === 'undefined' &&
							v.external_sensors_names[i]?.type === 'temperature'
						) {
							v.external_sensors_names[i + '_temperature'] = {};
							v.external_sensors_names[i + '_temperature'].name =
								v.external_sensors_names[i].name;
							delete v.external_sensors_names[i];
						}
					}
				}
				// write appliance type enum as a string prop to `relay usage` parameter
				if (
					typeof v.appliance_type !== 'undefined' &&
					(v?.relay_usage != castUsageStringToRelayUsageParam(getApplianceType(v)) ||
						typeof v?.relay_usage === 'undefined')
				) {
					console.log(
						'will change ',
						v.relay_usage,
						'to',
						castUsageStringToRelayUsageParam(getApplianceType(v)),
					);
					v.relay_usage = castUsageStringToRelayUsageParam(getApplianceType(v));
					edited_devices[v.id] = v;
				}

				// write rgbww_profile prop if missing for Pro RGBWW PM
				if (isRgbwwPm(v.type)) {
					if (typeof v.rgbww_profile === 'undefined') {
						v.rgbww_profile = devices_settings.getByRealId(
							real_id(v.id),
						)?.device?.sys?.profile;
						edited_devices[v.id] = v;
					}
				}
			} catch (error) {
				console.error('Error while fixing device interface data.', error);
			}
			v.room_id = Number(v.room_id);
			return v;
		});

	if (Object.values(edited_devices).length > 0) {
		const res = await postReq(`interface/device/bulk_update`, {
			devices_data: JSON.stringify(edited_devices),
		});

		if (res.isok) {
			console.log('Fixed devices', edited_devices);
		} else {
			console.error('Failed to edit device props at init');
		}
	}

	return fixed_devices;
};

const fix_bad_values_groups = async (groups) => {
	const edited_groups = {};
	const fixed_groups = Object.values(groups).map(async (v: any) => {
		// if(v.room_id == 0 ){
		// 	v.room_id = -1;
		// 	edited_groups[v.id] = {...v};
		// }

		if (Object.keys(get(rooms)).indexOf(v.room_id + '') === -1 && v.room_id != -1) {
			// edited_groups[v.id] =  {...v}
			const del_res = await postReq('interface/group/delete', { id: v.id });
			if (del_res.isok) {
				console.log('deleted hidden group with id:', v.id);
			}
		}

		if (v.isDndShadowItem) {
			console.warn('isDndShadowItem ', v);
			//first add bad group for Spazz to be able to delete prop
			//then for us delete it
			delete v.isDndShadowItem;
			edited_groups[v.id] = { ...v };
		}
		return v;
	});

	if (Object.keys(edited_groups).length > 0) {
		await postReq('interface/group/bulk_update', {
			groups_data: JSON.stringify(edited_groups),
		});
	}
	// ToDo: Please check this!!!
	return groups;
};

const fix_bad_values_rooms = async (rooms) => {
	const edited_rooms = {};
	const fixed_rooms = Object.values(rooms).map((v: any) => {
		if (typeof v.devices !== 'undefined') {
			delete v.devices;
			//here try to edit room in redis does not return what we expect so it is invalid request
			// edited_rooms[v.id] = v
		}
		if (v.isDndShadowItem) {
			//add it first to Spazz and then clear the prop for us
			delete v.isDndShadowItem;
			edited_rooms[v.id] = { ...v };
		}

		if (typeof v._meta !== 'undefined') {
			delete v._meta;
			delete v.do;
			delete v.if;
			delete v._enabled;
			delete v._run_on_ingest;
			edited_rooms[v.id] = v;
		}

		// Convert legacy backgroundColor format to new AvatarColorVariant format
		if (v?.backgroundColor) {
			const convertedColor = convertLegacyAvatarColors(v.backgroundColor);
			if (convertedColor !== v.backgroundColor) {
				v.backgroundColor = convertedColor;
				edited_rooms[v.id] = v;
			}
		}

		return v;
	});

	if (Object.values(edited_rooms).length > 0) {
		const res = await postReq(`interface/room/bulk_update`, {
			rooms_data: JSON.stringify(edited_rooms),
			force: true,
		});
		if (res.isok) {
			console.log('Edited rooms', edited_rooms);
		} else {
			console.warn('Failed to edit room props at init');
		}
	}

	return fixed_rooms;
};

const room_id_to_type = (groups, type) => {
	const edited_groups = {};

	for (const k in groups) {
		if (Object.prototype.hasOwnProperty.call(groups, k)) {
			const v = groups[k];
			if (type == 'num') {
				v.room_id = Number(v.room_id);
			} else if (type == 'str') {
				v.room_id = v.room_id + '';
			}
			edited_groups[k] = v;
		}
	}

	return edited_groups;
};

const fix_bad_values_dashboards = async (dashboards) => {
	const edited_dashboards = {};
	const fixed_dashboards = Object.values(dashboards).map((v: any) => {
		if (Array.isArray(v.rooms) && v.rooms.length > 0 && v.rooms.indexOf(null) > -1) {
			v.rooms = [];
			edited_dashboards[v.id] = v;
		}

		if (Array.isArray(v.groups) && v.groups.length > 0 && v.groups.indexOf(null) > -1) {
			v.groups = [];
			edited_dashboards[v.id] = v;
		}

		if (Array.isArray(v.scenes) && v.scenes.length > 0 && v.scenes.indexOf(null) > -1) {
			v.scenes = [];
			edited_dashboards[v.id] = v;
		}

		return v;
	});

	const url = '/interface/dash/update';

	if (Object.values(edited_dashboards).length > 0) {
		console.log('edited_dashboards', edited_dashboards);

		for (const key in edited_dashboards) {
			if (Object.prototype.hasOwnProperty.call(edited_dashboards, key)) {
				const dash = edited_dashboards[key];
				console.log('key', key);

				const res = await postReq(url, {
					id: key,
					data: JSON.stringify(dash),
				});

				if (res.isok) {
					console.log('Edit dash', key, dash);
				} else {
					console.warn('Failed to edit room props at init');
				}
			}
		}
	}

	return fixed_dashboards;
};

/**
 * Fixes unhandled device IDs inside the `if` and `do` blocks only for main scenes.
 *
 * This function:
 *  - Recursively scans each scene for device references (values of `rr` and `r` starting with `"dev:"`).
 *  - Extracts the device ID (middle part), optionally applies `_N` suffix rules for `iN` endings.
 *  - Converts decimal device IDs to padded hex using `decimal_to_hex()` (unless ID starts with XB/XM).
 *  - Adds extracted IDs into:
 *      - `_meta.cdi` → device IDs used inside **if**
 *      - `_meta.adi` → device IDs used inside **do**
 *  - Merges with existing `_meta.adi` / `_meta.cdi` while preserving order and avoiding duplicates.
 *  - Validates the final scene with `validate_scene()`.
 *  - Sends an API request (`POST /scene/edit`) to update each scene.
 *  - Processes scenes sequentially to avoid backend overload.
 *
 * @async
 * @function fix_unhandled_device_ids_in_scenes
 * @param {Object<string, ISceneObj>} raw_scenes
 *     A dictionary or map-like object where each value is a scene object.
 *     Typical usage: `get(scenes)` returns this structure.
 *
 * @returns {Promise<void>}
 *     Resolves when all scenes have been processed and updated.
 */
const fix_unhandled_device_ids_in_scenes = async (raw_scenes) => {
	let edited_scenes = {};

	const fixed_scenes = Object.values(raw_scenes).map((scene: ISceneObj) => {
		const ifSet = new Set();
		const doSet = new Set();

		// Recursively walk any node and collect 'rr' and 'r' that start with 'dev:'
		const collect = (node, targetSet) => {
			if (node == null) return;
			if (Array.isArray(node)) {
				for (const item of node) collect(item, targetSet);
				return;
			}
			if (typeof node === 'object') {
				for (const [k, v] of Object.entries(node)) {
					// direct device references
					if ((k === 'rr' || k === 'r') && typeof v === 'string' && v.startsWith('dev:')) {
						targetSet.add(normalizeDeviceRef(v));
						continue;
					}
					// dive deeper
					collect(v, targetSet);
				}
			}
		};

		// normalize "dev:123456789012:mt"  -> hex or XB/XM preserved + optional _N
		const normalizeDeviceRef = (raw) => {
			// defensive: expect "dev:middle:tail" but handle variants
			const parts = raw.split(':');
			const middle = parts[1] ?? '';
			const tail = parts[2] ?? '';

			// compute suffix from iN rule: if /^i(\d+)$/ and n>1 => _{n-1}
			let suffix = '';
			const im = tail.match(/^i(\d+)$/);
			if (im) {
				const n = Number(im[1]);
				if (n > 1) suffix = `_${n - 1}`;
			}

			let id = middle;

			// if id already starts with XB or XM -> keep as-is (no decimal->hex)
			if (!id.startsWith('XB') && !id.startsWith('XM')) {
				// convert decimal string -> hex using provided helper
				// if middle is empty or not numeric, keep original middle
				if (/^\d+$/.test(id)) {
					id = decimal_to_hex(id);
				}
			}

			return id + suffix;
		};

		// collect from if -> cdi, from do -> adi
		collect(scene.if, ifSet);
		collect(scene.do, doSet);

		// merge with existing _meta arrays (if present), preserving order and dedup
		const existingMeta: { [key: string]: any } =
			scene._meta && typeof scene._meta === 'object' ? scene._meta : {};

		const mergePreserveOrder = (existingArr, foundSet) => {
			const list = [];
			const seen = new Set();

			if (Array.isArray(existingArr)) {
				for (const v of existingArr) {
					if (!seen.has(v)) {
						list.push(v);
						seen.add(v);
					}
				}
			}

			for (const v of foundSet) {
				if (!seen.has(v)) {
					list.push(v);
					seen.add(v);
				}
			}

			return list;
		};

		const finalAdi = mergePreserveOrder(existingMeta.adi, doSet);
		const finalCdi = mergePreserveOrder(existingMeta.cdi, ifSet);

		// return a shallow copy of the scene, with updated _meta (merge other _meta props)
		const newMeta = {
			...(existingMeta || {}),
			adi: finalAdi,
			cdi: finalCdi,
		};

		const newScene = {
			...scene,
			_meta: newMeta,
		};

		if (validate_scene(newScene)) {
			if (newScene.id !== newScene._id) newScene.id = newScene._id;
			edited_scenes[newScene._id] = newScene;
			return newScene;
		}
	});

	if (Object.values(edited_scenes).length > 0) {
		const res = await postReq(`scene/bulk_update`, {
			scenes_data: JSON.stringify(edited_scenes),
		});
		if (res.isok) {
			console.log('Fixed scenes', edited_scenes);
		} else {
			throw new Error('Fixed scenes error');
		}
	}

	return fixed_scenes;
};

const getAllLists = async () => {
	const lists = (await postReq('/interface/device/get_all_lists', {}, 10000)) as AllListsRequest;

	if (lists?.isok && lists.data) {
		// ToDo: fix all loops here...
		const dev_fixed_dasheboards = await fix_bad_values_dashboards(lists.data.dashboards);
		dashboards.set(convert_array_to_object(dev_fixed_dasheboards, 'id'));

		const dev_room_id_to_number = await fix_bad_values_devices(lists.data.devices);
		devices.set(convert_array_to_object(dev_room_id_to_number, 'id'));

		const fixed_rooms = await fix_bad_values_rooms(lists.data.rooms);
		rooms.set(convert_array_to_object(fixed_rooms, 'id'));

		const fix_bad_groups = await fix_bad_values_groups(lists.data.groups);
		groups.set(room_id_to_type(fix_bad_groups, 'id'));

		// Used only to add device ids in the scene _meta object when are missing.
		// This only happens when the scene was made or edited before the 'Device Usage details' feature was introduced.
		// (https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2707)
		// Will be used very rarely, only for old scenes, mainly for single user cases.
		// Need to passing only the main scenes, without temp_schemes or alams in it.
		// const fixed_scenes = await fix_unhandled_device_ids_in_scenes(/* filtered scenes */);
		// scenes.set(convert_array_to_object(fixed_scenes, 'id'));

		device_ui.set(lists.data.dui);
	} else {
		// devices.set({})
		// groups.set({})
		// rooms.set({})
	}

	return { lists };
};

/**
 * Re-fetch the rights-scoped data (`device.rights`, `scene._meta.rights`) plus
 * the account settings holding the `sub` flag, so a `SUB_RIGHTS` housing socket
 * event can apply new permissions live without a full reload (FE-2022).
 */
export const refreshRightsScopedData = async (): Promise<void> => {
	await get_user_settings();
	await Promise.all([getAllLists(), get_scenes()]);
};

const fix_bad_values_scenes = async (scenes) => {
	// for (const key in scenes) {
	// 	if (Object.prototype.hasOwnProperty.call(scenes, key)) {
	// 		const element = scenes[key];
	// 		if (typeof element.tschem !== 'undefined') {
	// 			console.log(element)
	// 		}
	// 	}
	// }

	let edited_scenes = {};

	let fixed_scenes = Object.values(scenes).map((v: any) => {
		// fix scenes without a position prop in the _meta data
		if (typeof v._meta.position === 'undefined') {
			let same_room_scenes = Object.values(scenes).filter(
				(_v: any) =>
					_v._gui_function !== 'alarm' &&
					!_v.hasOwnProperty('tschem') &&
					_v._meta.room == v._meta.room &&
					_v._meta.id !== v._meta.id,
			);

			v._meta.position = 0;
			if (same_room_scenes.length > 0) {
				const max_pos_scene = same_room_scenes.reduce((prev, current) =>
					prev?._meta?.position > current?._meta?.position ? prev : current,
				);
				v._meta.position = max_pos_scene._meta.position + 1;
				edited_scenes[v._id] = v;
			}
		}

		if (v.id !== v._id) {
			console.warn('scene without an id prop');
			v.id = v._id;
			edited_scenes[v._id] = v;
		}

		return v;
	});

	// all fixed scenes are resaved here
	if (Object.values(edited_scenes).length > 0) {
		const res = await postReq(`scene/bulk_update`, {
			scenes_data: JSON.stringify(edited_scenes),
		});
		if (res.isok) {
			console.log('Fixed scenes', edited_scenes);
		} else {
			throw new Error('damn error');
		}
	}

	return fixed_scenes;
};

const get_scenes = async () => {
	const scenes_list: SceneListsRequest = await postReq('scene/list', {}, 10000);

	if (scenes_list?.isok) {
		scenes.set(scenes_list.data.scene_scripts);
	} else {
		scenes.set({});
	}
	return { scenes_list };
};

/**
 * Processes user profile data from user settings.
 *
 * @param data - User settings data from the backend.
 * @returns {void}
 *     Updates the profiles store with the new profile data.
 */
const processUserProfileFromUserSettings = (data: any) => {
	const stored_user = get(user_data);
	const isSub = typeof data.settings.sub === 'number';
	const rawName = isSub && data.settings.scr_name ? data.settings.scr_name : data.settings.name;
	const trimmedName = typeof rawName === 'string' ? rawName.trim() : '';
	const userIdStr = String(stored_user.user_id ?? '').trim();
	// The cloud sometimes returns the raw unit_id/user_id as the account name for
	// never-renamed accounts (e.g. right after registration). Drop it so the UI
	// falls back to the account email instead of showing an internal id.
	const name = userIdStr && trimmedName === userIdStr ? '' : trimmedName;

	let accountAvatar = data.settings.acc_avatar;

	// scr_avatar may come as a JSON string that needs parsing
	if (isSub) {
		try {
			accountAvatar =
				typeof data.settings.scr_avatar === 'string'
					? JSON.parse(data.settings.scr_avatar)
					: data.settings.scr_avatar;
		} catch {
			// If parsing fails, use the default avatar
		}
	}

	let accountAvatarObject = {};

	// Legacy handling of the old avatar format (string)
	if (typeof accountAvatar === 'string') {
		let image = undefined;
		let backgroundColor = undefined;

		if (!checkIfColorIsAvatarVariant(accountAvatar)) {
			image = accountAvatar;
		} else {
			backgroundColor = accountAvatar;
		}

		accountAvatarObject = {
			image,
			backgroundColor,
			avatarOptions: {
				type: stored_user?.premium ? 'premium' : null,
			},
		};
	} else {
		accountAvatarObject = {
			...accountAvatar,
			avatarOptions: {
				type: stored_user?.premium ? 'premium' : null,
			},
		};
	}

	const prevProfile = get(profiles).find((profile) => profile.email === stored_user.email);

	if (prevProfile) {
		profiles.edit({
			...prevProfile,
			title: name,
			acc_avatar: {
				...prevProfile.acc_avatar,
				...accountAvatarObject,
			},
		});
	} else {
		profiles.add({
			id: stored_user.user_id,
			email: stored_user.email,
			pass: stored_user.password,
			title: name,
			acc_avatar: {
				text: getProfileAvatarText(name, stored_user.email),
				...accountAvatarObject,
			},
			is_sub: isSub,
			installer: !!stored_user.installer,
			sub: data.settings.sub,
			isSelected: true,
		});
	}
};

export const get_user_settings = async () => {
	try {
		const res: UserSettingsRequest = await postReq('/user/get_settings', {});

		const stored_user = get(user_data);

		if (res?.isok) {
			user_settings.set(res.data.settings);

			processUserProfileFromUserSettings(res.data);
		}

		if (res?.isok && stored_user.premium && res.data.settings?.weather_station?.data?.stationName) {
			getWeatherStationData(res.data.settings?.weather_station?.l, true);
		}

		adaptingPowerPricesByTimeZoneIfOutdated();

		return res?.data?.settings;
	} catch (error) {
		console.error('error on getting user settings', error);
	}
};

export const get_profile_data = async () => {
	const res = (await getReq('/interface/profile/list', {}, 10000)) as UserProfileDataRequest;

	if (res?.isok) {
		const profile = normalizeProfileData(res.data?.profile || {});
		if (profile.layout?.backgroundColor) {
			profile.layout = {
				...profile.layout,
				backgroundColor: convertLegacyAvatarColors(profile.layout.backgroundColor),
			};
		}
		profile_data.set(profile);
	} else {
		profile_data.set({});
	}

	return res;
};

const migrateLegacyNewsletterPreference = async () => {
	const currentProfile = get(profile_data);
	if (currentProfile.showNewsletter !== undefined) return;

	const currentHome = get(home_data);
	const legacyPreference = getLegacyNewsletterPreference(currentProfile, currentHome);

	if (legacyPreference === undefined) return;

	profile_data.update(({ newsletterPrompt: _legacyPreference, ...profile }) => ({
		...profile,
		showNewsletter: legacyPreference,
	}));

	const res = await postReq('interface/profile/save', {
		id: 'showNewsletter',
		data: JSON.stringify(legacyPreference),
	});

	if (!res?.isok) {
		console.error('Failed to migrate the legacy newsletter profile preference.');
	}
};

export const get_home_data = async () => {
	let res: UserHomeDataRequest = await postReq('/interface/home/list', {}, 10000);

	if (res?.isok) {
		if (!get(app)) {
			// set online flag if the home data request passes. used to reset the flag on desktop after we are back online
			network.set('wi-fi');
		}

		const homeData = res.data?.home || {};

		if (typeof homeData.globalLocalControl == 'undefined') {
			console.log('res.data.home.globalLocalControl is undefined');
			home_data.set({
				...homeData,
				globalLocalControl: {
					useLocal: JSON.parse(localStorage.getItem('globalLocalControl'))?.useCloud || true,
				},
			});
		} else {
			home_data.set(homeData);
		}

		return res;
	} else {
		if (!get(app)) {
			// set offline flag if the home data request fails
			network.set('offline');
		}
	}
};

export function check_broken_fw(device, status, settings) {
	if (device?.gen == 2) {
		return false;
	} else {
		const _firmware = get(firmwares)[device?.type];

		if (typeof _firmware === 'undefined') {
			return false;
		} else {
			const dev_fw = settings?.fw;
			const dev_fw_ts = dev_fw?.split('/')[0].split('-')[0];
			if (FW_FOR_UPDATE.includes(dev_fw)) {
				return _firmware;
			} else if (device.type === 'SHDM-2' && dev_fw_ts == 20210225) {
				return _firmware;
			} else if (device.type === 'SHEM-3' && dev_fw_ts == 20200204) {
				return _firmware;
			} else {
				return false;
			}
			// return _firmware.version.split('/')[0] !== settings?.fw?.split('/')[0] ? _firmware: false
		}
	}
}

export async function get_all_fw_versions(options?: { forceTestFw?: boolean }) {
	let data = {
		force_test_fw: 0,
	};

	if (options?.forceTestFw || isDevServerUser(['repo', 'nb']) || isT1User()) {
		data.force_test_fw = 1;
	}

	try {
		const res_gen_1: GetFwVersionsRequest = await getReq('/files/firmware', data);

		if (res_gen_1 && 'isok' in res_gen_1 && !res_gen_1.isok) {
			console.error('Failed to get firmware versions');
			return;
		}

		(res_gen_1 as any).ts = Date.now();
		firmwares.set(res_gen_1);
	} catch (error) {
		return error;
	}
}

export async function get_all_fw_versions_gen_2() {
	try {
		const res_gen_2: GetFwVersionsRequest = await postReq('/files/gen2_list_fw', {});
		if (res_gen_2.isok) {
			res_gen_2.data.ts = Date.now();
			firmwares_gen_2.set(res_gen_2.data);
		} else {
			console.error('Failed to get firmware versions');
		}
	} catch (error) {
		return error;
	}
}
export async function get_all_fw_versions_gen_gble() {
	//gble firmwares list on repo for now
	try {
		// Firmware versions for GBLE devices are only available from the repo.
		const res_gen_gble: GetFwVersionsRequest = (await repo.get(
			'/files/gble_list_fw',
		)) as GetFwVersionsRequest;
		if (import.meta.env.DEV) {
			console.log('%cGBLE FW RESSS', 'color:blue; font-size:14px', res_gen_gble);
		}
		if (res_gen_gble.isok) {
			res_gen_gble.data.ts = Date.now();
			firmwares_gen_gble.set(res_gen_gble.data);
		} else {
			console.error('Failed to get gble firmware versions');
		}
	} catch (error) {
		return error;
	}
}

//#endregion Firmware check and pull

//#region Check AI Models
export async function checkAIBulk(devices) {
	try {
		const res = await postReq('device/bulk_check_ai', {
			devices: JSON.stringify(devices.map((device) => device.id)),
		});
		if (res.isok) {
			return res;
		} else {
			console.error('Failed to get AI models', res);
		}
	} catch (error) {
		console.log('%c error', 'color: orange', error);
		return {
			isok: false,
			error,
		};
	}
}
//#endregion Check AI Models

//#region 3rd party integrations

/** ask PHP API to exchange token from 3rd party system and store it */

export async function ask_php_to_exchange_token(data: {
	client: string;
	type: string;
	code: string;
	host: string;
}): Promise<ExchangeAccess> {
	try {
		const res = await postReq('/integrated_api/exchange_token', data, 4000);

		return res;
	} catch (error) {
		return {
			isok: false,
			error,
		};
	}
}

export async function enable_alexa_skill(data: {
	code: string;
	type: string;
	host: string;
}): Promise<AlexaSkillResponse> {
	try {
		let res = await postReq('/integrated_api/enable_alexa_skill', data, 6000);
		return res;
	} catch (error) {
		return {
			isok: false,
			error,
		};
	}
}

export const disable_skill = async (data) => {
	try {
		let res = await postReq('/integrated_api/disable_integration', data, 6000);
		return res;
	} catch (error) {
		return {
			isok: false,
			error,
		};
	}
};

export async function get_active_integrations() {
	let res: GetActiveIntegrationsRequest = await postReq('/integrated_api/get_active', {}, 3500);
	if (res?.isok) {
		active_integrations.set(res?.data?.integrations);
		console.log('Set up active integrations ', get(active_integrations));
	} else {
		console.log('Error on getting integrations', res);
	}
}

export async function get_oauth_code(
	email: string,
	password: string,
	client_id: string,
	unitId: string,
): Promise<OAuthResponse> {
	try {
		const res = await api.post(
			'oauth/login/',
			qs.stringify({
				client_id,
				email,
				password,
				unit: unitId,
				response_type: 'code',
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);
		return res.data;
	} catch (error) {
		console.log(error.response.data);
		console.log(error.response.status);
		console.log(error.response.headers);
		if (error.response.status >= 500) {
			toast.open({
				type: 'danger',
				title: _format('server_error_desc', {
					default: 'Server could not be reached. Please, try again.',
				}),
			});
		}

		return error.response.data;
	}
}

interface ExchangeAccess {
	isok: boolean;
	[key: string]: any;
}

interface UserData {
	email: string;
	password: string;
}

interface OAuthResponse {
	isok: boolean;
	data: {
		code: string;
		[key: string]: any;
	};
}

interface AlexaSkillResponse {
	isok: boolean;
	[key: string]: any;
}
/**
 * Handle return back to the Android, iOS and Web with valid code from Amazon
 * - params look like = "code=ANtmSyliOAboKWDCCOnj&state=YWxleGE=" (success)
 */
export async function comes_back_from_amazon(
	host: string,
	code: string,
	skill_stage: string,
	user_data: UserData,
	unitId: string,
): Promise<{ isok: boolean }> {
	console.warn('"comes_back_from_amazon" params', host, code, skill_stage);
	const exchange_access = await ask_php_to_exchange_token({
		client: 'alexa',
		type: skill_stage,
		code,
		host,
	});

	if (exchange_access.isok) {
		const res = await get_oauth_code(
			user_data.email,
			user_data.password,
			'shelly-alexa-skill',
			unitId,
		);

		if (res.isok) {
			let { code } = res.data;
			const enable_alexa = await enable_alexa_skill({
				code,
				type: skill_stage,
				host,
			});

			return { isok: enable_alexa?.isok };
		} else {
			console.error('Error on getting oauth code');
			return { isok: false };
		}
	}
	return { isok: false };
}

//#endregion 3rd party integrations
